<template>
  <div class="OnboardingModal">
    <div class="OnboardingModal-container">
      <h1 class="OnboardingModal-title">
        {{ views[step].title }}
      </h1>
      <p class="OnboardingModal-subtitle">
        {{ views[step].subtitle }}
      </p>
      <p v-if="views[step].tip">
        <span class="tip">{{
          $t('dashboard.studentDashboard.studentOnboardingModal.tip')
        }}</span
        >: {{ views[step].tip }}
      </p>
    </div>

    <div v-if="!mobileMode" class="seperator" />
    <div class="OnboardingModal-buttons">
      <large-button @click.native="nextStep()" class="large-button">
        <div class="next-button">
          {{ views[step].button }}
          <arrow-right-icon v-if="dir == 'ltr'" class="icon" />
          <arrow-left-icon v-else-if="dir == 'rtl'" class="icon" />
        </div>
      </large-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EVENTS } from '@/consts'
import AnalyticsService from '@/services/AnalyticsService'
import ArrowLeftIcon from '@/assets/left-arrow.svg'
import ArrowRightIcon from '@/assets/arrow.svg'
import LargeButton from '@/components/LargeButton.vue'

export default {
  name: 'StudentOnboardingModal',
  components: { LargeButton, ArrowLeftIcon, ArrowRightIcon },
  props: {
    modalData: { type: Object, required: true },
  },
  data() {
    return {
      step: 0,
      views: [
        {
          title: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-0.title'
          ),
          subtitle: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-0.subtitle'
          ),
          button: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-0.button'
          ),
        },
        {
          title: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-1.title'
          ),
          subtitle: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-1.subtitle'
          ),
          tip: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-1.tip'
          ),
          button: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-1.button'
          ),
        },
        {
          title: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-2.title'
          ),
          subtitle: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-2.subtitle'
          ),
          button: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-2.button'
          ),
        },
        {
          title: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-3.title'
          ),
          subtitle: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-3.subtitle'
          ),
          button: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-3.button'
          ),
        },
        {
          title: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-4.title'
          ),
          subtitle: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-4.subtitle'
          ),
          button: this.$root.$t(
            'dashboard.studentDashboard.studentOnboardingModal.views.step-4.button'
          ),
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      mobileMode: 'app/mobileMode',
      dir: 'app/direction',
    }),
  },
  created() {
    AnalyticsService.captureEvent(EVENTS.STUDENT_SHOWN_ONBOARDING_MODAL)
  },
  methods: {
    nextStep() {
      if (this.step === this.views.length - 1) {
        this.$store.dispatch('app/modal/hide')
        this.$store.dispatch('user/firstDashboardVisit', false)
        AnalyticsService.captureEvent(EVENTS.STUDENT_FINISHED_ONBOARDING_MODAL)
      } else {
        this.step += 1
      }
    },
  },
}
</script>

<style lang="scss" scoped>
h1,
h2,
p {
  margin: 0;
  padding: 0;
}

p {
  font-size: 16px;
  color: #77778b;
}

.OnboardingModal {
  @include flex-container(column);
  @include child-spacing(top, 24px);
  height: 100%;

  &-container {
    min-height: 180px;
  }
}

.OnboardingModal-title {
  @include font-category('display-small');
  margin-bottom: 1.4em;
  @include breakpoint-above('medium') {
    margin-top: 24px;
  }
}

.OnboardingModal-subtitle {
  @include font-category('heading');
  color: $c-secondary-grey;
  margin-bottom: 1em;
}

.OnboardingModal-buttons {
  @include flex-container(column);
  @include child-spacing(top, 16px);
  margin-top: auto;
  margin-bottom: 4em;

  @include breakpoint-above('medium') {
    @include child-spacing(top, 0);

    flex-direction: row;
    justify-content: flex-end;
    margin-top: 1.4em;
    margin-bottom: 0;
  }
}

.seperator {
  border: 1px solid $c-border-grey;
  width: 100%;
  height: 1px;
  margin-top: 2em;
}

.next-button {
  display: flex;
  align-items: center;
  border: none;
}

.large-button {
  color: white;
  background-color: $c-success-green;
  border: 1px solid $c-success-green;
  border-radius: 300px;
  margin-bottom: 0.5em;
  padding: 1em 0.4em;

  &:hover {
    border: 1px solid $c-success-green;
  }

  @include breakpoint-above('medium') {
    padding: 0.8em 1.8em;
  }
}

.icon {
  fill: white;
  margin-left: 1em;
  width: 20px;
  height: 20px;
}

.tip {
  font-weight: 600;
}

html.is-rtl {
  .icon {
    margin-right: 1em;
    margin-left: unset;
  }
}
</style>
